export default function Profile() {
    return <>
        <div className="py-10 md:py-16 lg:py-20 bg-primary-100 dark:bg-primary-500/20">
            <div className="px-4 sm:px-6 lg:px-8">

                <div className="grid grid-cols-1 md:grid-cols-2 md:items-center">
                    <div className="relative h-80 md:h-150 bg-surface rounded-2xl overflow-hidden">
                        <img className="absolute inset-0 size-full object-cover" src="/nitnot_emblem.png" alt="Testimonials Image" />
                        <div className="pointer-events-none absolute inset-0 rounded-2xl bg-[radial-gradient(circle_at_center,rgba(255,255,255,0)_40%,rgba(126,34,206,0.18)_100%)]" />
                    </div>
                    <div className="pt-10 md:p-10">
                        <blockquote className="max-w-4xl mx-auto">
                            <p className="mb-6 md:text-lg text-foreground">
                                A Family Tradition of Rich, Aromatic Coffee
                            </p>

                            <p className="text-xl sm:text-2xl lg:text-3xl lg:leading-normal text-foreground">
                                Coffee has the power to connect generations – whether it's learning grandma's brewing techniques and trying to perfect them just like her or the intense memories triggered by the rich flavors and aromas of our favorite coffee blends.
                            </p>

                            <footer className="mt-6 md:mt-10">
                                <button type="button" className="group inline-flex items-center gap-x-3 text-foreground text-sm focus:outline-hidden disabled:opacity-50 disabled:pointer-events-none">
                                    <span className="size-8 md:size-10 flex flex-col justify-center items-center bg-secondary border border-secondary-line text-secondary-foreground rounded-full group-hover:scale-105 group-focus:scale-105 transition-transform duration-300 ease-in-out">
                                        <svg className="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"></path>
                                        </svg>
                                    </span>
                                    Watch the Video
                                </button>
                            </footer>
                        </blockquote>
                    </div>

                </div>

            </div>
        </div>
    </>
}
